module.exports = __webpack_public_path__ + "static/buildingcups1-6a505d8e258925cf00e1593cb32c009c.jpeg";